import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GameCompassPreGameProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish: () => void;
}

function GameCompassPreGame(props: GameCompassPreGameProps) {
  const { playClick } = useContext(AudioContext);
  const [status, setStatus] = useState<'message' | 'message-1' | 'message-2' | ''>('message');

  const ShowMessage = () => {
    return <div className="modal modal-game-compass game-message">
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
        <p className="message">
          早於中國的戰國時期，
          <br/>已經有人利用磁石製成司南，
          <br/>即是羅盤的前身。
          <br/>宋代時，宋人將磁石技術改進，
          <br/>把磁性鐵片改為磁鋼針，製造出指南針。後來人們將指南針定在方位盤裏，製成羅盤。
          <br/>羅盤有助辨別方向，是海上航行最重要的儀器。
        </p>
      </div>
      <button className="button modal-button-next" onClick={() => { playClick(); setStatus('message-1'); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/game2-next-button`} src1=".svg" src2="-select.svg" alt="下一頁"></SvgButton>
      </button>
    </div>
  }
  const ShowMessage1 = () => {
    return <div className="modal modal-game-compass game-message-western">
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
        <p className="message">
          原來這麽有用，快點教我如何使用。
        </p>
      </div>
      <button className="button modal-button-next" onClick={() => { playClick(); setStatus('message-2'); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/game2-next-button`} src1=".svg" src2="-select.svg" alt="下一頁"></SvgButton>
      </button>
    </div>
  }
  const ShowMessage2 = () => {
    return <div className="modal modal-game-compass game-message game-message-2">
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
        <p className="message">
          好的，你現在就嘗試利用羅盤控制船隻到碼頭吧！
        </p>
      </div>
    </div>
  }

  return (
    <>
      {'' !== status
        ? <Modal>
          {'message' === status
            ? <ShowMessage />
            : 'message-1' === status
              ? <ShowMessage1 />
              : <ShowMessage2 />}
        </Modal>
        : null}
    </>
  )
}

export default GameCompassPreGame;
